
<div class="w2-confirm-choice-box col-xs-12 text-center">
	<h1>{{viewTitle}}</h1>
<!-- 		{{#each chosenItems}}
		<p>Lot {{lotNumber}}: {{title}}</p> 
		{{/each}} -->
	<p>{{message}}</p>
</div>


